var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FormGroup } from "react-bootstrap";
import styled, { css } from "styled-components";
var StyledFormGroup = styled(function (_a) {
    var flush = _a.flush, rest = __rest(_a, ["flush"]);
    return React.createElement(FormGroup, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .input-group .form-control {\n    z-index: auto;\n  }\n\n  ", "\n"], ["\n  .input-group .form-control {\n    z-index: auto;\n  }\n\n  ",
    "\n"])), function (_a) {
    var flush = _a.flush, theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .input-group-addon {\n      background-color: ", ";\n      border: 1px solid ", ";\n    }\n    .input-group-addon:first-child {\n      border-right: 0;\n    }\n    .input-group-addon:last-child {\n      border-left: 0;\n    }\n    margin-bottom: ", ";\n  "], ["\n    .input-group-addon {\n      background-color: ", ";\n      border: 1px solid ", ";\n    }\n    .input-group-addon:first-child {\n      border-right: 0;\n    }\n    .input-group-addon:last-child {\n      border-left: 0;\n    }\n    margin-bottom: ", ";\n  "])), theme.colors.utility.white, theme.colors.utility.subdued, flush ? 0 : theme.spacing.two);
});
export default StyledFormGroup;
var templateObject_1, templateObject_2;
